import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "../components/header/index";
import HomePage from "../components/home";
import Footer from "../components/footer";
import AboutRoutes from "../pages/about";
import Product from "../pages/products";
import OurNetworks from "../pages/network";
import Detail from "../pages/services/detail";
import BasePath from "../common";
import NewsDetail from "../pages/newsupdate/NewsDetail";
import Rates from "../pages/rates";
import RateDetail from "../pages/rates/rateDetail";
import Grievance from "../pages/grievance";
import InveestorRelation from "../pages/investor";
import ProductsList from "../pages/products/productsList";
import { LangProvider } from "../context/LangContext";
import NoMatch from "../common/noMatch";
import CareerForm from "../common/careerForm";

const MyRoutes = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const spinner = document.getElementById("spinner");
    const timer = setTimeout(() => {
      if (spinner) {
        spinner.style.display = "none";
      }
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) return null;

  return (
    <LangProvider>
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:slug" element={<BasePath />} />
        <Route path="about/:slug" element={<AboutRoutes />} />
        <Route path="careers/:slug" element={<CareerForm />} />
        <Route path="services/:slug" element={<Detail />} />
        <Route path="products" element={<ProductsList />} />
        <Route path="products/:slug" element={<Product />} />
        <Route path="network/:slug" element={<OurNetworks />} />
        <Route path=":category/:slug" element={<NewsDetail />} />
        <Route path="rates/:slug" element={<Rates />} />
        <Route path="rates/:category/:slug" element={<RateDetail />} />
        <Route path="grievance/:slug" element={<Grievance />} />
        <Route path="investor-relation/:slug" element={<InveestorRelation />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>

      <Footer />
    </LangProvider>
  );
};

export default MyRoutes;
